import React, {useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'

import {viewProduct} from '../bs-product-list/core/_requests'
import {EditProduct} from '../bs-product-form/EditProduct'

export const EditProductWrapper = () => {
  const {id} = useParams()
  const [data, setData] = useState<any>(null)
  useEffect(() => {
    viewProduct(id).then((res) => {
      setData(res?.data?.Data)
    })
  }, [])
  if (data) {
    return <EditProduct initialValues={data} />
  }
  return null
}
